import { Cancel, HourglassEmpty, MoreHoriz, } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useMemo, } from 'react';
import {
    MaterialReactTable,
    useMaterialReactTable,
    type MRT_ColumnDef,
} from 'material-react-table';
import { GridCheckCircleIcon } from "@mui/x-data-grid";

type PaymentHistory = {
    id: number;
    username: string
    plan: string;
    paymentType: string;
    price: string;
    status: string;
    date: string;
    paymentMethod: string;
};

const paymentHistory: PaymentHistory[] = [
    {
        id: 1,
        username: 'john_doe',
        plan: 'Base',
        paymentType: 'Monthly',
        price: "29.99",
        status: 'Success',
        date: '2025-05-01',
        paymentMethod: 'Card payment',
    },
    {
        id: 2,
        username: 'jane_smith',
        plan: 'Add Ons',
        paymentType: 'One Time',
        price: "9.99",
        status: 'Failed',
        date: '2024-08-12',
        paymentMethod: 'Card payment',
    },
    {
        id: 3,
        username: 'allen_stephen',
        plan: 'Base',
        paymentType: 'Yearly',
        price: "38.9",
        status: 'Success',
        date: '2025-05-10',
        paymentMethod: 'Bank Transfer',
    },
    {
        id: 4,
        username: 'daniel',
        plan: 'Enterprise',
        paymentType: 'Monthly',
        price: "48.9",
        status: 'Success',
        date: '2025-05-10',
        paymentMethod: 'Bank Transfer',
    },
    {
        id: 5,
        username: 'selva',
        plan: 'Customized plan',
        paymentType: 'One Time',
        price: "31.9",
        status: 'Success',
        date: '2025-05-10',
        paymentMethod: 'Bank Transfer',
    },
    {
        id: 6,
        username: 'anirudh',
        plan: 'Enterprise',
        paymentType: 'Monthly',
        price: "49.9",
        status: 'Pending',
        date: '2025-05-10',
        paymentMethod: 'Bank Transfer',
    }
];

export default function PaymentHistory() {


    const columns = useMemo<MRT_ColumnDef<PaymentHistory>[]>(
        () => [
            {
                accessorKey: 'id',
                header: 'ID',
                size: 50,
            },
            {
                accessorKey: 'username',
                header: 'User Name',
                size: 120,
            },
            {
                accessorKey: 'plan',
                header: 'Plan',
                size: 100,
            },

            {
                accessorKey: 'price',
                header: 'Price',
                size: 100,
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>();
                    return (
                        <Box display="flex" alignItems="center">
                            $
                            <Typography variant="body2">{value}</Typography>
                        </Box>
                    );
                },
            },
            {
                accessorKey: 'date',
                header: 'Date',
                size: 100,
            },
            {
                accessorKey: 'paymentType',
                header: 'Payment Type',
                size: 150,
            },
            {
                accessorKey: 'paymentMethod',
                header: 'Payment Method',
                size: 150,
            },
            {
                accessorKey: 'status',
                header: 'Status',
                size: 120,
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>();

                    const getIcon = () => {
                        switch (value.toLowerCase()) {
                            case 'success':
                                return <GridCheckCircleIcon sx={{ color: 'green', fontSize: 18, mr: 0.5 }} />;
                            case 'failed':
                                return <Cancel sx={{ color: 'red', fontSize: 18, mr: 0.5 }} />;

                            default:
                                return <HourglassEmpty sx={{ color: 'orange', fontSize: 18, mr: 0.5 }} />;
                        }
                    };

                    return (
                        <Box display="flex" alignItems="center">
                            {getIcon()}
                            <Typography variant="body2">{value}</Typography>
                        </Box>
                    );
                },
                // size: 120,
            },
            {
                id: 'actions',
                header: 'Actions',
                Cell: ({  }) => {
                    const handleClick = () => {
                    };

                    return (
                        <>
                            <IconButton onClick={handleClick}> <MoreHoriz sx={{ cursor: "pointer" }} /> </IconButton>
                           
                        </>
                    );
                },
            },

        ],
        [],
    );

    const data = useMemo<PaymentHistory[]>(
        () => paymentHistory,
        []
    );


    const table = useMaterialReactTable({
        columns,
        data,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        enableSorting: false,
        enableColumnActions: false,
        muiTableHeadRowProps: {
            sx: {
                height: "60px",

            }
        },
        muiTableBodyRowProps: {
            sx: {
                height: "50px",

            }
        },
        muiTableContainerProps: {
            sx: {
                width: "100%",
                maxWidth: { xs: "300px", sm: "600px", md: "100%" },
                overflowX: { xs: "scroll", lg: "unset" },
            },
        },
        muiTableProps: {
            sx: {
                tableLayout: 'fixed',


            },
        },
        enableFilters: false,
        enableGlobalFilter: false,
        positionToolbarAlertBanner: "none",
        renderTopToolbar: false,
        enableHiding: false,
        initialState: { showColumnFilters: true, density: "compact", },
        muiTablePaperProps: {
            elevation: 0, //change the mui box shadow
            //customize paper styles
            sx: {

                p: "10px 0px 20px 20px"
            },
        },

        //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    });

    return (
        <>
            <MaterialReactTable table={table} />
        </>
    )
}
